// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How the bytes of a `Blob` are stored.
 */
export enum BlobEncoding {
  Raw = 0,
  Deflate = 1,
}
